const merchantEvent = adapter => message => {
  adapter.callAction('merchantEvent', { eventBody: message })
}

export default merchantEvent
